import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {  NgxUiLoaderModule } from 'ngx-ui-loader';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { MultiselectDropdownModule } from 'angular-2-dropdown-multiselect';
import { NgxPaginationModule } from 'ngx-pagination';
import { PipesModule } from 'src/app/theme/pipes/pipes.module';
import { ColumnChooserService, FilterService, GridModule, PageService, ResizeService, SortService } from '@syncfusion/ej2-angular-grids';
import { NgSelectModule } from '@ng-select/ng-select';
import { MaskedTextBoxModule } from '@syncfusion/ej2-angular-inputs';
import { CommonHttpService } from 'src/app/common.service';
import { HomeHealthAgencyComponent } from './home-health-agency.component';
import { HomeHealthAgencyModuleRoutingModule } from './home-health-agency-routing.module';
@NgModule({
  declarations: [HomeHealthAgencyComponent],
  imports: [
    CommonModule,
       FormsModule,
       ReactiveFormsModule,
       NgbModule,
       MultiselectDropdownModule,
       NgxPaginationModule,
       PipesModule,
       GridModule,
       NgSelectModule,
       NgxUiLoaderModule,
       MaskedTextBoxModule,
       HomeHealthAgencyModuleRoutingModule
  ],
  exports:[HomeHealthAgencyComponent],
    providers: [CommonHttpService,ColumnChooserService,PageService,SortService,FilterService,ResizeService ],
})
export class HomeHealthAgencyModule { }